import { drawerWidth } from './styleVariables';

export const PATH_AFTER_LOGIN = '/';

export const NAV = {
  W_BASE: 240
};

drawerWidth;
